<template>
  <v-container>
    <v-breadcrumbs
      class="mt-n4"
      large
    >
      <v-btn
        class="text-primary"
        text
        @click="backPrevios()"
      >
        <v-icon>mdi-keyboard-backspace</v-icon>
      </v-btn>
      ເລືອກລູກຄ້າເຂົ້າແຜນລວມ (ຄົວເຮືອນ + ຫົວໜ່ວຍທຸລະກິດ)
      <v-spacer />
      <span class="mr-4">
        <v-icon color="red">mdi-map-marker</v-icon>ຍັງບໍທັນຢູ່ໃນແຜນ
      </span>
      <span>
        <v-icon style="color: #49a3da">mdi-map-marker</v-icon>ຢູ່ໃນແຜນແລ້ວ
      </span>
    </v-breadcrumbs>
    <v-row class="my-n4">
      <v-col
        class="mb-4"
        cols="12"
      >
        <GmapMap
          :center="
            getCenter().lat > 0 || getCenter().lat < 0
              ? getCenter()
              : { lat: 0, lng: 0 }
          "
          :disable-default-u-i="true"
          :zoom="14"
          style="width: 100%; height: 450px"
        >
          <gmap-info-window
            :conent="infoContent"
            :opened="infoOpened"
            :options="infoOptions"
            :position="infoPosition"
            @closeclick="infoOpened = false"
          >
            {{ infoContent }}
          </gmap-info-window>
          <GmapMarker
            v-for="(m, index) in displayCustomers"
            :key="index"
            :animation="2"
            :clickable="true"
            :draggable="false"
            :icon="getSiteIcon(m)"
            :label="pickNumber(m) ? pickNumber(m).toString() : null"
            :position="getMarkers(m)"
            @click="toggleInfo(m, index)"
          />
        </GmapMap>
      </v-col>
    </v-row>
    <v-row class="mb-n6">
      <v-col>
        <v-btn
          class="btn-primary"
          @click="listDialog = true"
        >
          <v-icon>mdi-format-list-bulleted</v-icon>
          ລາຍການລູກຄ້າ ({{ selectedRows.length }})
        </v-btn>
      </v-col>
      <v-col>
        <h4>ແຜນ: {{ planName }}</h4>
        <h4>ລູກຄ້າທັງໝົດ {{ displayCustomers.length }} ຄົນ</h4>
      </v-col>
      <v-col>
        <v-btn-toggle
          v-model="selectedType"
          dense
          mandatory
        >
          <v-btn value="all">
            ທັງໝົດ
          </v-btn>
          <v-btn value="home">
            ຄົວເຮືອນ
          </v-btn>
          <v-btn value="company">
            ຫົວໜ່ວຍທຸລະກິດ
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="selectedDistrict"
          :items="districts"
          clearable
          dense
          item-text="name"
          item-value="id"
          label="ເມືອງ"
          outlined
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="selectedVillage"
          :items="villages"
          chips
          clearable
          dense
          item-text="name"
          item-value="id"
          label="ເລືອກບ້ານ"
          multiple
          outlined
        >
          <template v-slot:selection="data">
            <v-chip
              :input-value="data.selected"
              close
              v-bind="data.attrs"
              @click="data.select"
              @click:close="remove(data.item)"
            >
              {{ data.item.name }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

    <!-- Village Detail -->
    <v-row>
      <VillageDetail
        v-model="selectedDetails"
        :selected-village="selectedVillage"
      />
    </v-row>

    <v-row>
      <v-col cols>
        <v-select
          v-model="selectedFavoriteDate"
          :items="favorite_dates"
          dense
          item-text="name"
          item-value="name"
          label="ມື້ບໍລິການ"
          multiple
          outlined
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="selectedCustomerStatus"
          :items="customerStatus"
          clearable
          dense
          item-text="name"
          item-value="value"
          label="ສະຖານະລູກຄ້າ"
          multiple
          outlined
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="selectedCustomerCanCollects"
          :items="customerCanCollects"
          clearable
          dense
          item-text="text"
          item-value="value"
          label="ສະຖານະໃຫ້ເກັບ"
          outlined
        />
      </v-col>
      <v-col>
        <v-select
          v-model="selectedCost"
          :items="costs"
          clearable
          dense
          item-text="name"
          item-value="value"
          label="ປະເພດບໍລິການ"
          multiple
          outlined
        />
      </v-col>
      <v-col>
        <v-text-field
          v-model="search"
          clearable
          dense
          label="ຊື່ / ID / ເບີໂທ"
          outlined
          prepend-inner-icon="mdi-magnify"
          type="text"
          @keyup.enter="fetchSearch()"
        />
      </v-col>
      <v-col>
        <v-btn
          color="green"
          dark
          style="width:100%"
          @click="fetchSearch"
        >
          ຄົ້ນຫາ
        </v-btn>
      </v-col>
    </v-row>

    <div>
      <v-card>
        <v-card flat>
          <v-card-text>
            <v-row v-if="selectedRows.length">
              <v-col>
                <p>ລູກຄ້າທີ່ເລືອກ {{ selectedRows.length }}</p>
              </v-col>
              <v-col
                v-for="trash in selectedTrash"
                :key="trash.cost_by"
              >
                <p>
                  {{
                    getLaoCompanyCostByFunc(trash.cost_by) +
                      ": " +
                      Intl.NumberFormat().format(trash.count) +
                      " " +
                      getCustomerUnitFunc(trash.cost_by)
                  }}
                </p>
              </v-col>
            </v-row>
            <v-data-table
              :disable-pagination="true"
              :headers="headers"
              :items="displayCustomers"
              hide-default-footer
            >
              <template v-slot:item.display_name="{ item }">
                {{ displayName(item) }}
              </template>

              <template v-slot:item.customer_type="{ item }">
                <v-chip
                  dark
                  :color="item.customer_type == 'company' ? 'blue' : 'green'"
                >
                  {{ item.customer_type == 'company' ? 'ຫົວໜ່ວຍທຸລະກິດ' : 'ຄົວເຮືອນ' }}
                </v-chip>
              </template>

              <template v-slot:item.village_details="{ item }">
                <v-chip
                  v-for="villageItem in item.village_details"
                  :key="villageItem.id"
                >
                  {{
                    `${villageItem.village_variation.name}: ${villageItem.name}`
                  }}
                </v-chip>
              </template>

              <template v-slot:item.can_collect="{ item }">
                <v-chip
                  dark
                  :color="item.can_collect ? 'green' : 'orange'"
                >
                  {{
                    item.can_collect ? 'ເກັບໄດ້': 'ເກັບບໍ່ໄດ້'
                  }}
                </v-chip>
              </template>

              <template v-slot:item.cost_by="{ item }">
                <div>{{ costBy(item.cost_by) }}</div>
              </template>

              <template v-slot:item.custom_pick="{ item }">
                <div
                  class="main-check"
                  @click="checkHandler(item)"
                >
                  <div
                    v-if="pickNumber(item)"
                    class="check"
                  >
                    {{ pickNumber(item) }}
                  </div>
                  <div
                    v-else
                    class="uncheck"
                  />
                </div>
              </template>

              <template v-slot:item.expect_trash="{ item }">
                <v-chip
                  v-if="item.expect_trash"
                  color="green"
                  outlined
                >
                  {{ Intl.NumberFormat().format(item.expect_trash) }}
                  {{ getCustomerUnitFunc(item.cost_by) }}
                </v-chip>
                <div v-else>
                  -
                </div>
              </template>

              <template v-slot:item.favorite_dates="{ item }">
                <v-chip
                  v-for="date in item.favorite_dates"
                  :key="date.name"
                  color="green"
                  dark
                >
                  {{ date.name }}
                </v-chip>
              </template>
            </v-data-table>
            <br>
            <template>
              <Pagination
                v-if="pagination.total_pages > 1"
                :offset="offset"
                :pagination="pagination"
                @paginate="fetchAll()"
              />
              <v-btn
                v-if="homeState.next_page_url || companyState.next_page_url"
                dark
                style="width:100%"
                @click="fetchAll()"
              >
                ກຳລັງໂຫຼດຂໍ້ມູນໃຫ້ທ່ານ ກະລຸນາລໍຖ້າຈົນກ່ວາຂໍ້ຄວາມນິ້ຈະຫາຍໄປ...
              </v-btn>
            </template>
          </v-card-text>
        </v-card>
      </v-card>
    </div>

    <v-btn
      bottom
      color="primary"
      dark
      fixed
      right
      @click="listDialog = true"
    >
      <v-icon>mdi-format-list-bulleted</v-icon>
      ລາຍການລູກຄ້າ ({{ selectedRows.length }})
    </v-btn>

    <!--Forced plan-name dialog-->
    <v-dialog
      v-model="nameDialog"
      max-width="480"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="headline">ຕັ້ງຊື່ແຜນລວມ</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="planNameInput"
            label="ຊື່ແຜນ *"
            required
            autofocus
            @keyup.enter="confirmPlanName()"
          />
          <p class="errors">
            {{ nameError }}
          </p>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              @click="cancelPlanName()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="confirmPlanName()"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--Member list dialog: reorder, remove, save-->
    <v-dialog
      v-model="listDialog"
      max-width="760"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ planName }} — ລູກຄ້າ {{ selectedRows.length }}</span>
        </v-card-title>
        <v-card-text>
          <main class="page page--table">
            <v-data-table
              :disable-pagination="true"
              :headers="listHeaders"
              :items="selectedRows"
              hide-default-footer
              item-key="id"
              class="page__table"
            >
              <template v-slot:body="props">
                <draggable
                  :list="props.items"
                  tag="tbody"
                  @change="orderCustomer"
                >
                  <tr
                    v-for="(item, index) in props.items"
                    :key="item.id"
                  >
                    <td>
                      <v-icon
                        small
                        class="page__grab-icon"
                      >
                        mdi-arrow-all
                      </v-icon>
                    </td>
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.id }}</td>
                    <td>{{ displayName(item) }}</td>
                    <td>
                      <v-chip
                        dark
                        small
                        :color="item.customer_type == 'company' ? 'blue' : 'green'"
                      >
                        {{ item.customer_type == 'company' ? 'ຫົວໜ່ວຍທຸລະກິດ' : 'ຄົວເຮືອນ' }}
                      </v-chip>
                    </td>
                    <td>
                      <v-icon
                        small
                        @click="checkHandler(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </td>
                  </tr>
                </draggable>
              </template>
            </v-data-table>
          </main>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              @click="listDialog = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              :loading="loading"
              :disabled="loading"
              @click="saveRoutePlan()"
            >
              ບັນທຶກແຜນ
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable';
import queryOption from '@/Helpers/queryOption';
import {
  getCustomerUnit,
  getLaoCompanyCostBy,
  getCompanyCostBy,
  getCustomerCanCollect,
} from '@/Helpers/Customer';
import VillageDetail from '@/components/select/VillageDetail';

export default {
  name: 'SelectMixedToRoute',
  components: {
    VillageDetail,
    draggable,
  },
  data() {
    return {
      selectedDetails: [],
      selectedType: 'all',
      // Name-first flow: taken from ?name= or forced via dialog on mount.
      planName: '',
      planNameInput: '',
      nameDialog: false,
      nameError: '',
      listDialog: false,
      listHeaders: [
        { text: '', value: '', sortable: false },
        { text: '#', value: '', sortable: false },
        { text: 'Id', value: 'id', sortable: false },
        { text: 'ລູກຄ້າ', value: '', sortable: false },
        { text: 'ປະເພດ', value: '', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ],
      // Per-endpoint fetch state: home rows come from GET customer,
      // company rows from GET company (both endpoints are type-pure).
      homeState: {
        endpoint: 'customer',
        customers: [],
        pagination: {},
        next_page_url: '',
      },
      companyState: {
        endpoint: 'company',
        customers: [],
        pagination: {},
        next_page_url: '',
      },
      customerCanCollects: getCustomerCanCollect,
      selectedCustomerCanCollects: '',
      loading: false,
      // Pagination
      offset: 12,
      per_page: 100,
      cursor_paginate: 0,
      search: '',
      // Filter
      districts: [],
      selectedDistrict: '',
      villages: [],
      selectedVillage: [],
      selectedCustomerStatus: [],
      customerStatus: [
        {
          id: 1,
          value: 'calendar',
          name: 'ຍັງບໍ່ມີແຜນເດີນລົດ',
        },
        {
          id: 2,
          value: 'route_plan',
          name: 'ຍັງບໍ່ມີເສັ້ນທາງເກັບຂີ້ເຫື້ຍອ',
        },
      ],
      selectedCost: [],
      costs: [
        {
          id: 1,
          value: 'container',
          name: 'ຄອນເທັນເນີ',
        },
        {
          id: 2,
          value: 'fix_cost',
          name: 'ທຸລະກິດເປັນຖ້ຽວ',
        },
        {
          id: 3,
          value: 'chartered',
          name: 'ມອບເໝົາ',
        },
        {
          id: 4,
          value: 'bag',
          name: 'ບໍລິມາດ',
        },
        {
          id: 5,
          value: '32km',
          name: 'ຫຼັກ32',
        },
        {
          id: 6,
          value: 'infect',
          name: 'ຂີ້ເຫຍື້ອຕິດເຊື້ອ',
        },
      ],
      favorite_dates: [],
      selectedFavoriteDate: [],
      selectedRows: [],
      headers: [
        { text: '', value: 'custom_pick', sortable: false },
        { text: 'ID', value: 'customer_id' },
        { text: 'ລູກຄ້າ', value: 'display_name', sortable: false },
        { text: 'ປະເພດລູກຄ້າ', value: 'customer_type' },
        { text: 'ເບີໂທ', value: 'user.phone', sortable: false },
        { text: 'ປະເພດບໍລິການ', value: 'cost_by', sortable: true },
        { text: 'ສະຖານະໃຫ້ເກັບ', value: 'can_collect' },
        { text: 'ລາຍລະອຽດທີ່ຢູ່', value: 'village_details', sortable: true },
        { text: 'ບ້ານ', value: 'village.name', sortable: true },
        { text: 'ເມືອງ', value: 'district.name', sortable: true },
        { text: 'ລາຍລະອຽດການບໍລິການ', value: 'collect_description' },
        { text: 'ຂີ້ເຫຍື້ອຄາດໝາຍ', value: 'expect_trash' },
        { text: 'ວັນທີ່ສະດວກເກັບ', value: 'favorite_dates' },
        { text: 'ວັນທີ່ເພີ່ມເຂົ້າ', value: 'created_at' },
      ],
      server_errors: {},
      // Map
      latlng: {
        lat: 0,
        lng: 0,
      },
      infoPosition: null,
      infoContent: null,
      infoOpened: false,
      infoCurrentKey: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      currentPage: '',
    };
  },
  computed: {
    displayCustomers() {
      if (this.selectedType == 'home') return this.homeState.customers;
      if (this.selectedType == 'company') return this.companyState.customers;
      return this.homeState.customers.concat(this.companyState.customers);
    },
    pagination() {
      // One pager drives both endpoints; show the longer of the two.
      const home = this.homeState.pagination;
      const company = this.companyState.pagination;
      if ((home.total_pages || 0) >= (company.total_pages || 0)) return home;
      return company;
    },
    selectedTrash() {
      const array = [];

      for (const item of getCompanyCostBy) {
        array.push({
          cost_by: item.en,
          count: 0,
        });
      }

      for (const selected of this.selectedRows) {
        const index = array.findIndex(
          (item) => item.cost_by == selected.cost_by,
        );
        if (index > -1) {
          array[index].count
              += selected.expect_trash > 0 ? selected.expect_trash : 0;
        }
      }

      return array;
    },
  },
  watch: {
    selectedCustomerCanCollects() {
      this.resetAndFetch();
    },
    selectedFavoriteDate() {
      this.resetAndFetch();
    },
    search(value) {
      if (value == '') this.resetAndFetch();
    },
    selectedDistrict() {
      this.fetchVillage();
    },
    selectedCustomerStatus() {
      this.resetAndFetch();
    },
    selectedCost() {
      this.resetAndFetch();
    },
  },
  created() {
    // Name is mandatory before picking: take it from the query or force
    // the dialog (deep links / refreshes land here without one).
    if (this.$route.query.name && this.$route.query.name.trim()) {
      this.planName = this.$route.query.name.trim();
    } else {
      this.nameDialog = true;
    }
    this.fetchAll();
    this.fetchAddress();
    this.fetchFavorite();
  },
  methods: {
    displayName(item) {
      if (item.customer_type == 'company') return item.company_name;
      return `${item.name || ''} ${item.surname || ''}`;
    },
    fetchSearch() {
      this.resetAndFetch();
    },
    resetAndFetch() {
      this.currentPage = '';
      this.homeState.next_page_url = '';
      this.companyState.next_page_url = '';
      // Drop any stored page so a new search/filter starts from page 1 —
      // fetchAll() re-reads current_page from the pagination state.
      this.homeState.pagination.current_page = '';
      this.companyState.pagination.current_page = '';
      this.fetchAll();
    },
    backPrevios() {
      this.$router.go(-1);
    },
    getCustomerUnitFunc(costBy) {
      return getCustomerUnit(costBy);
    },
    getLaoCompanyCostByFunc(costBy) {
      return getLaoCompanyCostBy(costBy);
    },

    checkHandler(value) {
      // Toggle membership: any member can be removed, not just the last one.
      const index = this.selectedRows.findIndex((item) => item.id == value.id);
      if (index > -1) {
        this.selectedRows.splice(index, 1);
      } else {
        this.selectedRows.push(value);
      }
    },
    pickNumber(item) {
      const index = this.selectedRows.findIndex((row) => row.id == item.id);
      return index > -1 ? index + 1 : null;
    },
    orderCustomer(evt) {
      const { oldIndex, newIndex } = evt.moved;
      const tmpOrder = this.selectedRows[oldIndex];
      this.selectedRows.splice(oldIndex, 1);
      this.selectedRows.splice(newIndex, 0, tmpOrder);
    },
    confirmPlanName() {
      if (!this.planNameInput || !this.planNameInput.trim()) {
        this.nameError = 'ກະລຸນາຕັ້ງຊື່ແຜນກ່ອນ';
        return;
      }
      this.planName = this.planNameInput.trim();
      this.nameDialog = false;
    },
    cancelPlanName() {
      this.$router.push({
        name: 'Plan',
        query: { tab: 'all' },
      });
    },
    saveRoutePlan() {
      if (!this.selectedRows.length) {
        this.$store.commit('Toast_State', {
          value: true,
          color: 'error',
          msg: 'ກາລຸນາເລືອກລູກຄ້າກ່ອນ',
        });
        return;
      }
      this.loading = true;
      this.$store.commit('Loading_State', true);
      this.$axios
        .post('create-route-plan', {
          name: this.planName,
          customers: this.selectedRows.map((item) => item.id),
        })
        .then((res) => {
          if (res.status == 200) {
            this.$store.commit('Loading_State', false);
            this.loading = false;
            this.$store.commit('Toast_State', {
              value: true,
              color: 'success',
              msg: 'ບັນທຶກແຜນສຳເລັດແລ້ວ',
            });
            this.$router.push({
              name: 'Plan',
              query: { tab: 'all' },
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$store.commit('Loading_State', false);
          this.$store.commit('Toast_State', {
            value: true,
            color: 'error',
            msg: error.response
              ? error.response.data.message
              : 'Something went wrong',
          });
        });
    },
    async fetchAll() {
      this.currentPage = this.pagination.current_page;
      await Promise.all([
        this.fetchType(this.homeState),
        this.fetchType(this.companyState),
      ]);
    },
    async fetchType(state) {
      try {
        if (this.selectedDistrict) {
          this.per_page = 0;
          this.cursor_paginate = 1500;
        } else {
          this.per_page = 100;
          this.cursor_paginate = 0;
          state.next_page_url = '';
        }

        const options = [
          { page: this.currentPage },
          { cursor_paginate: this.cursor_paginate },
          { per_page: this.per_page },
          { without: this.selectedCustomerStatus },
          { without_month_info: true },
          { without_billing_summary: true },
          { villages: this.selectedVillage },
          { district_id: this.selectedDistrict },
          { filter: this.search },
          { cost_by: this.selectedCost },
          { favorite_dates: this.selectedFavoriteDate },
          { village_details: this.selectedDetails },
          { customer_can_collect: this.selectedCustomerCanCollects },
        ];

        this.$store.commit('Loading_State', true);

        const res = await this.$axios.get(
          state.next_page_url ? state.next_page_url : state.endpoint,
          {
            params: queryOption(options),
          },
        );

        if (res.data.code == 200) {
          this.$store.commit('Loading_State', false);
          if (state.next_page_url) {
            state.customers = state.customers.concat(res.data.data.data);
          } else {
            state.customers = res.data.data.data;
          }
          if (!this.cursor_paginate) state.pagination = res.data.data.pagination;
          state.next_page_url = res.data.data.next_page_url;
          if (state.next_page_url) {
            setTimeout(async () => {
              // Stop the auto-chain once the user navigated away.
              if (this._isDestroyed) return;
              await this.fetchType(state);
            }, 1000);
          }
        }
      } catch (error) {
        this.$store.commit('Loading_State', false);

        this.$store.commit('Toast_State', {
          value: true,
          color: 'error',
          msg: error.response ? error.response.data.message : 'Something went wrong',
        });

        if (error.response && error.response.status == 422) {
          const obj = error.response.data.errors || error.response.data.data || {};
          for (const [key, message] of Object.entries(obj)) {
            this.server_errors[key] = Array.isArray(message) ? message[0] : message;
          }
        }
      }
    },

    fetchAddress() {
      this.$axios
        .get('info/address', { params: { filter: 'ນະຄອນຫລວງວຽງຈັນ' } })
        .then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.address = res.data.data;
              this.address.map((item) => {
                this.districts = item.districts;
              });
            }, 300);
          }
        })
        .catch(() => {
        });
    },

    fetchVillage() {
      if (this.selectedDistrict) {
        this.$axios
          .get(`info/district/${this.selectedDistrict}/village`)
          .then((res) => {
            if (res.data.code == 200) {
              setTimeout(() => {
                this.villages = res.data.data;
              }, 300);
            }
          })
          .catch(() => {
          });
      }
    },

    remove(item) {
      const index = this.selectedVillage.indexOf(item.id);
      if (index >= 0) this.selectedVillage.splice(index, 1);
    },

    // Google map
    getCenter() {
      const customers = this.displayCustomers;
      if (customers && customers.length) {
        if (parseFloat(customers[0].lat) == null) {
          return this.latlng;
        }
        return {
          lat: parseFloat(customers[0].lat),
          lng: parseFloat(customers[0].lng),
        };
      }
      return this.latlng;
    },
    getMarkers(m) {
      if (m.customer !== null) {
        return {
          lat: parseFloat(m.lat),
          lng: parseFloat(m.lng),
        };
      }
    },
    getSiteIcon(status) {
      const pin1 = {
        url: require('@coms/../../src/assets/pin1.svg'),
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        size: {
          width: 35,
          height: 55,
          f: 'px',
          b: 'px',
        },
        scaledSize: {
          width: 35,
          height: 55,
          f: 'px',
          b: 'px',
        },
      };
      const pin2 = {
        url: require('@coms/../../src/assets/pin2.svg'),
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        size: {
          width: 35,
          height: 55,
          f: 'px',
          b: 'px',
        },
        scaledSize: {
          width: 35,
          height: 55,
          f: 'px',
          b: 'px',
        },
      };

      try {
        switch (status.route_plan_details_count) {
          case 0:
            return pin1;
          case 1:
            return pin2;
        }
      } catch (e) {
        return pin1;
      }
      return pin1;
    },
    toggleInfo(m, key) {
      this.infoPosition = this.getMarkers(m);
      this.infoContent = `${this.displayName(m)} (${m.user ? m.user.phone : ''}) `;
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }

      this.checkHandler(m);
    },
    costBy(value) {
      if (value == 'container') return 'ຄອນເທັນເນີ';
      if (value == 'fix_cost') return 'ທຸລະກິດເປັນຖ້ຽວ';
      if (value == 'chartered') return 'ມອບເໝົາ';
      if (value == 'infect') return 'ຂີ້ເຫຍື້ອຕິດເຊື້ອ';
      if (value == '32km') return 'ຫຼັກ32';
      if (value == 'bag') return 'ບໍລິມາດ';
      return value;
    },
    fetchFavorite() {
      this.$axios
        .get('favorite-date')
        .then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.favorite_dates = res.data.data;
            }, 100);
          }
        })
        .catch(() => {
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../../../../public/scss/main.scss";

.check {
  height: 20px;
  width: 100%;
  background-color: cornflowerblue;
  color: white;
  text-align: center;
}

.uncheck {
  height: 20px;
  width: 20px;
  border: 1px solid black;
}

.main-check {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
